import React, { createContext, useState, useContext, useEffect, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation } from "react-router-dom";
import axios from "axios";
// Đảm bảo đường dẫn css này đúng với cấu trúc thư mục của bạn
import "./game.css"; 

const GameContext = createContext();

export const useGame = () => useContext(GameContext);

export const GameProvider = ({ children }) => {
    // --- STATE GIAO DIỆN ---
    const [isGameActive, setGameActive] = useState(false);
    const [playGameUrl, setPlayGameUrl] = useState(null);
    const [gameTitle, setGameTitle] = useState("");
    const [activeGameId, setActiveGameId] = useState(null);

    // --- LOGIC NGẦM ---
    const activeProductIdRef = useRef(null); 
    const [isClosing, setClosing] = useState(false);
    const location = useLocation();

    // Cấu hình Axios
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );

    // =================================================================
    // HÀM RÚT TIỀN TỰ ĐỘNG
    // =================================================================
    const autoWithdrawMoney = async (specificId = null) => {
        let currentId = specificId || activeProductIdRef.current || localStorage.getItem("STUCK_GAME_ID");
        
        if (!currentId) return;
        currentId = String(currentId);

        try {
            const resBalance = await axios.post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { 
                product_type: currentId 
            });
            
            const rawBalance = Number(resBalance.data?.data?.balance || 0);
            const moneyToWithdraw = Math.floor(rawBalance);

            if (moneyToWithdraw > 0) {
                try {
                    await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                        product_type: currentId,
                        type: 2, 
                        money: moneyToWithdraw 
                    });
                } catch (errTransfer) {
                    // Silent fail
                }
            }
        } catch (error) {
            // Silent fail
        } finally {
            activeProductIdRef.current = null;
            setActiveGameId(null);
            localStorage.removeItem("STUCK_GAME_ID");
            
            setTimeout(() => {
                window.dispatchEvent(new Event("balanceUpdated"));
            }, 500);
        }
    };

    // =================================================================
    // CÁC EFFECT TỰ ĐỘNG
    // =================================================================
    
    // 1. Khi F5 (Reload trang): Kiểm tra tiền kẹt
    useEffect(() => {
        if (localStorage.getItem("user")) {
            autoWithdrawMoney();
        }
    }, []);

    // 2. Khi chuyển trang (Router Change): Đóng game để tránh lỗi hiển thị
    useEffect(() => {
        if (activeProductIdRef.current) {
            closeGlobalGame();
        }
    }, [location.pathname]);

    // [ĐÃ XÓA] Đoạn code tự động đóng game khi ẩn tab/chuyển app
    // useEffect(() => { ... }, []); <-- Đã bỏ đoạn này

    // --- HÀM MỞ GAME ---
    const openGlobalGame = (url, title = "Casino", productId = null) => {
        if (url) {
            const strProductId = String(productId);
            setPlayGameUrl(url);
            setGameTitle(title);
            setGameActive(true);
            
            activeProductIdRef.current = strProductId;
            setActiveGameId(strProductId); 
            if(strProductId) localStorage.setItem("STUCK_GAME_ID", strProductId);
        }
    };

    // --- HÀM ĐÓNG GAME ---
    const closeGlobalGame = async () => {
        if (isClosing) return;
        setClosing(true);
        
        setGameActive(false);
        setPlayGameUrl(null);
        setGameTitle("");

        await autoWithdrawMoney(); 

        setClosing(false);
    };

    return (
        <GameContext.Provider value={{ openGlobalGame, closeGlobalGame, isGameActive, activeGameId }}>
            {children}
            
            {/* GIAO DIỆN OVERLAY GAME */}
            {isGameActive && playGameUrl && (
                <div className="game-iframe-wrapper">
                    <div className="game-toolbar-control">
                        
                        {/* 1. Tên Game (Bên trái) */}
                        <span className="game-status-text">
                             <b style={{ color: "#f1c40f" }}>{gameTitle}</b>
                        </span>
                        
                        {/* 2. LOGO (Ở GIỮA) */}
                        <img 
                            alt="Logo" 
                            src="/images/logo.png" 
                            className="game-toolbar-logo" 
                        />

                        {/* 3. Nút Thoát (Bên phải) */}
                        <button className="btn-close-game" onClick={closeGlobalGame} disabled={isClosing}>
                            {isClosing ? (
                                <span>Đang xử lý...</span>
                            ) : (
                                <>
                                    <CloseIcon sx={{ fontSize: "18px" }} /> Thoát
                                </>
                            )}
                        </button>
                    </div>
                    
                    <iframe
                        src={playGameUrl}
                        className="game-iframe-screen"
                        title="Global Game Frame"
                        allowFullScreen
                        frameBorder="0"
                    ></iframe>
                </div>
            )}
        </GameContext.Provider>
    );
};